(function (global){
// This fixes a build issue when running on node
global.self = global;
require('es6-promise').polyfill();
require('fetch-everywhere');
const querystring = require('querystring');
var merge = require('./helpers/merge');
var timeoutPromise = require('./helpers/timeout-promise');
//var URL = 'https://oji7prpx5h.execute-api.us-west-2.amazonaws.com/staging/v1';
var URL = 'https://oji7prpx5h.execute-api.us-west-2.amazonaws.com/staging/v1';
//var URL = 'http://localhost:3000/v1';


var getFileNameFromContentDispostionHeader = function (header) {
    var contentDispostion = header ? header.split(';') : [];
    const fileNameToken = 'filename=';

    var fileName = 'download.csv';
    for (var i = 0; i < contentDispostion.length; i++) {
        var thisValue = contentDispostion[i];
        if (thisValue.trim().indexOf(fileNameToken) === 0) {
            fileName = decodeURIComponent(thisValue.trim().replace(fileNameToken, ''));
            break;
        }
    }

    return fileName;
};

/**
 * @class BabouJS
 */
function BabouJS() {
    this.api_key = undefined;
    this.setURL(URL);
}

/**
 * Sets the babou API Key
 *
 * @function setApiKey
 * @param {String} api_key
 */
function setApiKey(api_key) {
    this.api_key = api_key;
}
BabouJS.prototype.setApiKey = setApiKey;

/**
 * Allows you to manually override the base URL. By default
 * it will be https://9tjmnysfqf.execute-api.us-west-2.amazonaws.com/production/babou
 *
 * @function setURL
 * @param {String} url
 */
function setURL(url) {
    this.BASE_URL = url.endsWith('/v1') ? url.substr(0, url.length - 3): url;
    const pathSeperator = this.BASE_URL.endsWith('/') ? '' : '/';
    this.URL = [this.BASE_URL, 'v1'].join(pathSeperator);
    this.URL2 = [this.BASE_URL, 'v2'].join(pathSeperator);
}

BabouJS.prototype.setURL = setURL;

/**
 * Allows you to set the API Key and Base URL in one call
 *
 * @function setConfig
 * @param {Object} config
 */
function setConfig(config) {
    if(!config) return this;
    if(config.url) this.setURL(config.url);
    if(config.api_key) this.setApiKey(config.api_key);
    return this;
}
BabouJS.prototype.setConfig = setConfig;

/**
 * By default it will include the preferred_profile of
 * the agent.
 *
 * @function getPreferredAgent
 * @param {Object} agent
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Boolean} [options.include_followers=false]
 * @param {Boolean} [options.include_aliases=false]
 * @param {Boolean} [options.include_listings=false]
 * @param {Boolean} [options.include_buys=false]
 * @param {Boolean} [options.include_buying_stats=false]
 * @param {Boolean} [options.include_last_bought=false]
 * @param {Boolean} [options.include_last_listing=false]
 * @param {Boolean} [options.disable_master_agent_upsert=false]
 * @param {Number} [options.include_new_listings=0] - Number of new listings to return
 * @param {Number} [options.include_open_houses=0] - Number of listings with open houses to return
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function getPreferredAgent(agent, options) {
    var defaultOptions = {
        cache: true,
        include_followers: false,
        include_aliases: false,
        include_listings: false,
        include_buys: false,
        include_buying_stats: false,
        include_last_bought: false,
        include_last_listing: false,
        disable_master_agent_upsert: false,
        timeout: 10000,
        retries: 0
    }
    options = merge(defaultOptions, options);
    var body = {
        "agent": agent,
        "options": options
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if(!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                return jsonObj.data;
            }

            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > options.retries) {
                throw err;
            } else {
                return _startFetch(retryCount);
            }
        });
    }
}
BabouJS.prototype.getPreferredAgent = getPreferredAgent;


/**
 *
 *
 *
 * @function searchListings
 * @param {Object[]} areas - The areas we want to search listings in
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Boolean} [options.include_listings=false]
 * @param {Boolean} [options.include_listing_stats=false]
 * @param {Boolean} [options.include_market_segments=false]
 * @param {Boolean} [options.enhance_listings_with_preferred_vendor_ids=true] - Enhance listings with preferred vendor id
 * @param {Boolean} [options.useSourceZipBlacklist=false] - flag to use source zipcode blacklist
 * @param {String} [options.orderBy=ListingDate:desc] - can sort by 'ListingDate:desc', 'ListPrice:desc', 'ListPrice:asc', or 'OpenHouseDate:asc'
 * @param {Number} [options.limit=48] - number of listings per page
 * @param {Number} [options.skip=0] - go to page that includes this record
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.include_new_listings=0] - Number of new listings to return
 * @param {Number} [options.include_open_houses=0] - Number of listings with open houses to return
 * @param {('Active'|'Pending'|'Inactive')} [options.active_statuses=null] - The type of normalized status to consider as active for the purpose of the search

 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchListings(areas, options) {
    var defaultOptions = {
        cache: true,
        include_listings: false,
        include_listing_stats: true,
        include_market_segments: false,
        enhance_listings_with_preferred_vendor_ids: false,
        include_open_houses: false,
        useSourceZipBlacklist: false,
        orderBy: 'ListingDate:desc',
        limit: 48,
        skip: 0,
        timeout: 10000,
        include_new_listings: 0,
        include_abn_buyers: 0,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "areas": areas,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/listings/search'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchListings = searchListings;


/**
 * Fetches listings similar to the address provided
 *
 *
 * @function getSimilarListings
 * @param {Object} [params]
 * @param {String} [params.address] - The address to look for
 * @param {Object} [params.orderBy] - whether to sort using any of the keys available in elasticsearch
 *
*/
function getSimilarListings(params) {
    const options = { params: params };
    return this.callApi('/listings/similar', options);
}
BabouJS.prototype.getSimilarListings = getSimilarListings;


/**
 *
 *
 *
 * @function buyerStats
 * @param {Object[]} areas - The areas we want to search listings in
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function buyerStats(areas, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "areas": areas,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/sold/stats'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.buyerStats = buyerStats;


/**
 *
 *
 *
 * @function searchAgents
 * @param {String} type - The type of activity we are searching. Can be either 'listing' or 'seller'
 * @param {Object[]} areas - The areas we want to search activity in
 * @param {Object} [options] - Super set of getPreferredAgent
 * @param {Boolean} [options.cache=true] - Flag to use cached data
 * @param {String} [options.orderBy=preferred_profile.name:desc] - pass through to lodash orderBy. Can sort by result before being enhanced by getPreferredAgent options
 * @param {Number} [options.limit=30] - number of agents per page
 * @param {Number} [options.skip=0] - go to page that includes this record
 * @param {Boolean} [options.include_followers=false]
 * @param {Boolean} [options.include_aliases=false]
 * @param {Boolean} [options.include_buying_stats=false]
 * @param {Boolean} [options.include_buys=false]
 * @param {Boolean} [options.include_last_bought=false]
 * @param {Boolean} [options.include_last_listing=false]
 * @param {Number} [options.include_new_listings=0] - Number of new listings to return
 * @param {Number} [options.include_open_houses=0] - Number of listings with open houses to return
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchAgents(type, areas, options) {
    var defaultOptions = {
        cache: true,
        include_listings: false,
        include_aliases: false,
        include_buying_stats: false,
        include_buys: false,
        include_last_bought: false,
        include_last_listing: false,
        include_open_houses: 0,
        orderBy: 'preferred_profile.name:desc',
        limit: 48,
        skip: 0,
        timeout: 10000,
        include_new_listings: 0,
        include_abn_buyers: 0,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "query": {"areas": areas, "type": type},
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/agents/search'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchAgents = searchAgents;


/**
 * Allows you to call a babou API using fetch
 *
 *
 * @function callApi
 * @param {String} path - The Babou Path to hit
 * @param {Object} [options] - All fetch options are available to be passed in here
 * @param {Object} [options.params] - fetch does not allow query string params,
 * but we allow that in the options object here

*/
function callApi(path, options) {
    // if '/' wasn't passed in the path, add it to the path
    if(path[0] !== '/') path = '/' + path;

    // add parameters since fetch doesn't do it for us
    if(options.params && Object.keys(options.params).length) {
        var esc = encodeURIComponent;
        var query = Object.keys(options.params)
            .map(function(k) { return esc(k) + '=' + esc(options.params[k]) })
            .join('&');
        path = path + '?' + query;
        delete options.params;
    }

    // set the auth headers
    if(!options.headers) options.headers = {};
    options.headers['Content-Type'] = 'application/json';
    options.headers['x-api-key'] = this.api_key;

    var url = [this.URL, path].join('');
    return fetch(url, options)
    .then(function (response) {
        if (response.status >= 400) {
            throw new Error('Bad response from server');
        }

        return response.json();
    });
};
BabouJS.prototype.callApi = callApi;


/**
 *
 *
 *
 * @function getMasterAgentData
 * @param {Object} agent - The agent we wish to get data on
 * @param {Object} [options] - options
 */
function getMasterAgentData(agent, options) {
    options = options || {};
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "agent": agent,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/master-agent/data'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getMasterAgentData = getMasterAgentData;


/**
 *
 *
 *
 * @function upsertMasterAgent
 * @param {Object} agent - The agent we wish to get data on
 * @param {Object} [options] - options
 * @param {Object} [options.calculateStats] - recalculate agent statistics
 */
function upsertMasterAgent(agent, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "agent": agent,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/master-agent'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.upsertMasterAgent = upsertMasterAgent;


/**
 *
 *
 *
 * @function setMasterAgent
 * @param {Object} agent - The agent we wish to get data on
 * @param {Object} [options] - options
 */
function setMasterAgent(id, agent, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = agent;

    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/master-agent/', id].join(''), {
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            console.log("response:", response);
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.setMasterAgent = setMasterAgent;


/**
 *
 *
 *
 * @function updateMasterAgentStatsByIds
 * @param {[Object]} masterAgentIds - ids of records in our master agent collection
 * @param {Object} [options] - options
 */
function updateMasterAgentStatsByIds(masterAgentIds, options) {
    var defaultOptions = {
        timeout: 30000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "ids": masterAgentIds,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/master-agent/update_stats'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.updateMasterAgentStatsByIds = updateMasterAgentStatsByIds;


/**
 *
 *
 *
 * @function getOutdatedStatsMasterAgentIds
 * @param {Object} limit - number of ids of master agent records with outdated stats
 * @param {Object} [options] - options
 */
function getOutdatedStatsMasterAgentIds(limit, options) {
    limit = limit != null ? limit : 20;
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/master-agent/old_stats?limit=', limit].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getOutdatedStatsMasterAgentIds = getOutdatedStatsMasterAgentIds;


/**
 *
 *
 *
 * @function getMasterAgentRecordById
 * @param {Object} id - id of a master agent record
 * @param {Object} [options] - options
 */
function getMasterAgentRecordById(id, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/master-agent/', id].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getMasterAgentRecordById = getMasterAgentRecordById;


/**
 *
 *
 *
 * @function updateMasterAgentStats
 * @param {Object} id - id of a master agent record to be update
 * @param {Object} [options] - options
 */
function updateMasterAgentStats(id, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/master-agent/', id, '/update_stats'].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.updateMasterAgentStats = updateMasterAgentStats;

/**
 *
 *
 *
 * @function searchMasterAgent
 * @param {Object} params - params to search master agent profiles
 * @param {String} [params.email] - email to search by
 * @param {String} [params.license_number] - realtor license number to search by
 * @param {String} [params.portal_user_id] - portal user id to search by
 * @param {String} [params.company] - company (use with state) to search by
 * @param {String} [params.state] - state (use with company) to search by
 * @param {String} [params.phone_number] - realtor phone number to search by
 * @param {String} [params.first_name] - realtor first name to search by
 * @param {String} [params.last_name] - realtor last name to search by

 * @param {Object} [options] - options
 */
function searchMasterAgent(params, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var queryS = querystring.stringify(params);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/master-agent/search?', queryS].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchMasterAgent= searchMasterAgent;



/**
 *
 *
 *
 * @function getAgentReferralSuggestions
 * @param {Object} [query] - An object to pass query params into
 * @param {Array} [query.portal_user_ids] - A list of portal user ids
 * @param {Array} [query.suggestion_ids] - A list of suggestion ids
 * @param {Array} [query.suggested_agent_emails] - A list of suggested agent emails
 * @param {Object} [options] - options
 */
function getAgentReferralSuggestions(query, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    // legacy API: query used to be only portal_user_ids (string or array), so treat it as such
    // if query is a string, split it by , so we convert to an array
    if(typeof query === 'string') {
        const portal_user_ids = query.split(',').map(function (item) {
            return item.trim();
        });
        query = { portal_user_ids: portal_user_ids };
    } else if(Array.isArray(query)) {
        const portal_user_ids = query;
        query = { portal_user_ids: portal_user_ids };
    }

    options = merge(defaultOptions, options);
    var body = {
        query: query,
        options: options,
    }

    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent/agent-referral-suggestions'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if(!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > options.retries) {
                throw err;
            } else {
                return _startFetch(retryCount);
            }
        });
    }
}
BabouJS.prototype.getAgentReferralSuggestions = getAgentReferralSuggestions;



/**
 *
 *
 *
 * @function excludeAgentReferralSuggestions
 * @param {Array} [exclusions] - A list of object of portal user ids and emails
 *                               to exclude for the user
 * @param {Array.Object} [portal_user_id] - The portal_user_id to add the exclusion to
 * @param {Array.Object} [suggested_agent_email] - The email to exclude for the portal user id
 * @param {Object} [options] - options
 */
function excludeAgentReferralSuggestions(exclusions, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    options = merge(defaultOptions, options);
    var body = {
        exclusions: exclusions,
        options: options,
    }

    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent/exclude-agent-referral-suggestions'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if (!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }

                return response.json();
            })
            .then(function (jsonObj) {
                return jsonObj;
            })
            .catch(function onError(err) {
                retryCount++;

                if (retryCount > options.retries) {
                    throw err;
                } else {
                    return _startFetch(retryCount);
                }
            });
    }
}
BabouJS.prototype.excludeAgentReferralSuggestions = excludeAgentReferralSuggestions;


/**
 *
 *
 *
 * @function excludeSuggestedAgentsForLO
 * @param {Array} [exclusions] - A list of object of LO portal user ids and agent ids
 *                               to exclude for the LO user
 * @param {Array.Object.String} [lo_id] - The LO ID to add the exclusion for
 * @param {Array.Object.String} [suggested_agent_id] - The agent ID to exclude for the portal user id or NMLS id
 * @param {Object} [options] - options
 */
function excludeSuggestedAgentsForLO(exclusions, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    options = merge(defaultOptions, options);
    var body = {
        exclusions: exclusions,
        options: options,
    }

    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/loan-officer/exclude-agent-suggestions'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if (!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }

                return response.json();
            })
            .then(function (jsonObj) {
                return jsonObj;
            })
            .catch(function onError(err) {
                retryCount++;

                if (retryCount > options.retries) {
                    throw err;
                } else {
                    return _startFetch(retryCount);
                }
            });
    }
}
BabouJS.prototype.excludeSuggestedAgentsForLO = excludeSuggestedAgentsForLO;



/**
 * Gets the raw listing straight from the source database
 *
 *
 * @function getRawListing
 * @param {String} [source] - The source for the listing: wolfnet/rets
 * @param {listingId} [listingId] - The listingId of the listing to fetch
 * @param {Object} [options] - options
 */
function getRawListing(source, listingId, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    options = merge(defaultOptions, options);

    var URL = [this.URL, 'listings/raw', source, listingId].join('/');
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch(URL, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
        });

        if (!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }

                return response.json();
            })
            .then(function (jsonObj) {
                return jsonObj;
            })
            .catch(function onError(err) {
                retryCount++;

                if (retryCount > options.retries) {
                    throw err;
                } else {
                    return _startFetch(retryCount);
                }
            });
    }
}
BabouJS.prototype.getRawListing = getRawListing;



/**
 *
 *
 *
 * @function searchAgentOffice
 * @param {Object[]} areas - The areas we want to search agent office located in. Only support zipcode and city
 * @param {Object} [options]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchAgentOffice(areas, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "query": { areas: areas },
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/agent-office/searchByArea'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchAgentOffice = searchAgentOffice;



/**
 *
 *
 *
 * @function refreshAllAirtableCaches
 * @param {Object} [options]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function refreshAllAirtableCaches(options) {
    var defaultOptions = {
        timeout: 20000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/cache/refreshAirTableData'].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.refreshAllAirtableCaches = refreshAllAirtableCaches;



/**
 *
 *
 *
 * @function refreshAirtableData
 * @param {String} airtableService=["blacklistedSourceZipcode", "propertyTypeValue", "listingStatus"] - Airtable service data to be refresh. Must specify one of the three supported service.
 * @param {Object} [options]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function refreshAirtableData(airtableService, options) {
    var defaultOptions = {
        timeout: 20000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/airtable/', airtableService, '/refresh'].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.refreshAirtableData = refreshAirtableData;



/**
 *
 *
 *
 * @function getAirtableData
 * @param {String} geteService=["blacklistedSourceZipcode", "propertyTypeValue", "listingStatus"] - Airtable service data to be refresh. Must specify one of the three supported service.
 * @param {Object} [options]
 * @param {Number} [options.noCache=0] - if noCache is 1, service will retrieve fresh data from airtable.
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function getAirtableData(airtableService, options) {
    var defaultOptions = {
        timeout: 20000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;
    var NO_CACHE = options && options.noCache ? options.noCache : 0;
    var SERVICE_URL = [URL, '/airtable/', airtableService, '?noCache=', NO_CACHE].join('');

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;


        var promise = fetch(SERVICE_URL, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getAirtableData = getAirtableData;


/**
 * Gets the AVM data for a list of IDs
 *
 *
 * @function getAvm
 * @param {String[]} avmIds - Comma separated list of ids, can be 'apn:fipscode' or 'dpid'
 * @param {Object} [params] - params
 * @param {Number} [params.limit] - Number of records to fetch [defaults to 100]
 * @param {String} [params.orderBy] - The sort order of the records [defaults to createdate desc]
 * @param {String} [params.lookupKey] - The lookup key for the ids, one of 'apn:fipscode' or 'dpid' [defaults to 'apn:fipscode']
 * @param {Object} [options] - Other babou options
 */
function getAvm(avmIds, params, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0,
    };
    const qsParams = {
        limit: params.limit || 100,
        orderBy: params.orderBy || 'createdate desc',
        lookupKey: params.lookupKey || 'apn:fipscode',
    };

    var queryS = querystring.stringify(qsParams);

    options = merge(defaultOptions, options || {});

    var URL = [this.URL, 'avm', avmIds.join(',')].join('/');
    URL = URL + '?' + queryS;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch(URL, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            params: {
                limit: options.limit,
                orderBy: options.orderBy,
            }
        });

        if (!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }

                return response.json();
            })
            .then(function (jsonObj) {
                return jsonObj;
            })
            .catch(function onError(err) {
                retryCount++;

                if (retryCount > options.retries) {
                    throw err;
                } else {
                    return _startFetch(retryCount);
                }
            });
    }
}
BabouJS.prototype.getAvm = getAvm;


/**
 *
 * @function getSuggestedLOs
 * @param {Object} agent
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function getSuggestedLOs(agent, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        retries: 0
    }
    options = merge(defaultOptions, options);
    var body = {
        "agent": agent,
        "options": options
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent/lo-suggestions'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if(!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                return jsonObj.data;
            }

            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > options.retries) {
                throw err;
            } else {
                return _startFetch(retryCount);
            }
        });
    }
}
BabouJS.prototype.getSuggestedLOs = getSuggestedLOs;


/**
 *
 * @function getLoanOfficerProduction
 * @param {String[]} nmlsIds - The nmlsIds of LOs we want production for
 * @param {String} since - Only return production after this date
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function getLoanOfficerProduction(nmlsIds, since, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        retries: 0
    }
    options = merge(defaultOptions, options);
    var body = {
        "nmlsIds": nmlsIds,
        "since": since,
        "options": options
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/loan-officer-production'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if(!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                return jsonObj.data;
            }

            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > options.retries) {
                throw err;
            } else {
                return _startFetch(retryCount);
            }
        });
    }
}
BabouJS.prototype.getLoanOfficerProduction = getLoanOfficerProduction;


/**
 *
 *
 *
 * @function getSuggestedAgentsByNmlsId
 * @param {Object} id - NMLS id of a loan officer
 * @param {Object} [options] - options
 * @param {Boolean} [options.use_exclusion_list=false] - If true, will use the exclusion list for the User ID
 */
function getSuggestedAgentsByNmlsId(id, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        use_exclusion_list: false,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;
    var queryS = querystring.stringify({ use_exclusion_list: mergedOptions.use_exclusion_list });

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/loan-officer/nmlsId/', id, '/suggestedAgents', '?', queryS].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                return jsonObj.data;
            }

            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getSuggestedAgentsByNmlsId = getSuggestedAgentsByNmlsId;


/**
 *
 *
 *
 * @function getSuggestedAgentsByUserId
 * @param {Object} id - Portal user id of a loan officer
 * @param {Object} [options] - options
 * @param {Boolean} [options.use_exclusion_list=false] - If true, will use the exclusion list for the User ID
 */
function getSuggestedAgentsByUserId(id, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        use_exclusion_list: false,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;
    var queryS = querystring.stringify({ use_exclusion_list: mergedOptions.use_exclusion_list });

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/loan-officer/userId/', id, '/suggestedAgents', '?', queryS].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                return jsonObj.data;
            }

            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getSuggestedAgentsByUserId = getSuggestedAgentsByUserId;



/**
 *
 *
 *
 * @function searchAgentsV2
 * @param {String} type - The type of activity we are searching. Can be 'listing', 'seller', or 'either'
 * @param {Object[]} areas - The areas we want to search activity in
 * @param {Object} [options] - Object of options
 * @param {Boolean} [options.cache=true] - Flag to use cached data
 * @param {String} [options.orderBy=AGENT_NAME:desc] - pass through to lodash orderBy. Can sort by by any field returned
 * @param {String} [options.q] - Value to filter results by agent or office name
 * @param {Number} [options.limit=30] - number of agents per page
 * @param {Number} [options.skip=0] - go to page that includes this record
 * @param {String} [options.format=json] - the format of the response, can be 'json' or 'csv'
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchAgentsV2(type, areas, options) {
    var defaultOptions = {
        cache: true,
        orderBy: 'AGENT_NAME:desc',
        limit: 48,
        skip: 0,
        format: 'json',
        timeout: 10000,
        include_new_listings: 0,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "query": {"areas": areas, "type": type},
        "options": mergedOptions
    }
    var URL = this.URL2;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/agents/search'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            if(mergedOptions.format === 'csv') {
                return response.blob().then(function (blob) {
                    return {
                        filename: getFileNameFromContentDispostionHeader(response.headers.get('content-disposition')),
                        blob: blob,
                    };
                })
            }
            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchAgentsV2 = searchAgentsV2;


/**
 * By default it will include the preferred_profile of
 * the agent.
 *
 * @function getPreferredAgent
 * @param {String} pii - either vander id or agent email
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function getAgentInfo(pii, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        retries: 0
    }
    options = merge(defaultOptions, options);
    var body = {
        "pii": pii,
        "options": options
    }
    var URL = this.URL2;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if(!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                return jsonObj.data;
            }

            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > options.retries) {
                throw err;
            } else {
                return _startFetch(retryCount);
            }
        });
    }
}
BabouJS.prototype.getAgentInfo = getAgentInfo;


/**
 *
 *
 *
 * @function getAgentIntelEventLogByNmlsId
 * @param {Object} id - NMLS id of a loan officer
 * @param {Object} [options] - options
 */
function getAgentIntelEventLogByNmlsId(id, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var queryS = options && Object.keys(options).length ? querystring.stringify(options) : null;
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;
        var urlParts = [URL, '/loan-officer/nmlsId/', id, '/agentIntelEventLog'];

        if (queryS) {
            urlParts.push('?', queryS);
        }

        var promise = fetch(urlParts.join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
            .then(function(response) {
                if(response.status >= 400) {
                    throw new Error("Bad response from server");
                }

                return response.json();
            })
            .then(function(jsonObj) {
                if(Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                    return jsonObj.data;
                }

                return jsonObj;
            })
            .catch(function onError(err) {
                retryCount++;

                if(retryCount > mergedOptions.retries) {
                    throw err;
                } else {
                    // On retries, cache is true so we can pick up
                    // where we left off on the last try
                    delay = (
                        (initial_delay || 0) *
                        Math.pow(2, retryCount - 1)
                    );

                    return new Promise(function(resolve, reject) {
                        setTimeout(
                            function() {
                                _startFetch(retryCount)
                                    .then(resolve)
                                    .catch(reject);
                            },
                            delay
                        )
                    });
                }
            });
    }
}
BabouJS.prototype.getAgentIntelEventLogByNmlsId = getAgentIntelEventLogByNmlsId;


module.exports = new BabouJS();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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